import * as React from 'react'

import { Plus, Share2, SquarePen, Trash2 } from 'lucide-react'
import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import SectionButton, { ISavedFiltersSection } from './components/SectionButton'

// localization: translated

interface ISavedFiltersActionBarProps {
  selectedCustomFilterId: string
  appliedCustomFilterId: string
  editCustomFilter: () => void
  deleteCustomFilter: () => void
  onSaveFiltersClicked: () => void
}

@observer
export default class SavedFiltersActionBar extends React.Component<ISavedFiltersActionBarProps> {
  private sections: ISavedFiltersSection[] = [
    {
      getLabel: () => Localization.translator.edit_verb,
      icon: <SquarePen data-icon="inline-start" />,
      onClick: this.clickOnEdit.bind(this),
    },
    {
      getLabel: () => Localization.translator.share,
      icon: <Share2 data-icon="inline-start" />,
      onClick: this.clickOnShare.bind(this),
      isDisabled: true,
    },
    {
      getLabel: () => Localization.translator.delete,
      icon: <Trash2 data-icon="inline-start" />,
      onClick: this.clickOnDelete.bind(this),
    },
  ]

  public constructor(props: ISavedFiltersActionBarProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const isBarDisabled = !this.isCustomFilterSelected

    return (
      <div className="tw:flex tw:items-center px10 mt5 mb10">
        {this.sections.map((section, index) => (
          <SectionButton
            key={index}
            isDisabled={isBarDisabled}
            section={section}
          />
        ))}
        <Button
          variant="primary-ghost"
          className="tw:ml-auto"
          onClick={this.clickOnSave}
        >
          <Plus data-icon="inline-start" />
          {Localization.translator.saveCurrentFilters}
        </Button>
      </div>
    )
  }

  public get isCustomFilterSelected() {
    const { selectedCustomFilterId, appliedCustomFilterId } = this.props
    return selectedCustomFilterId || appliedCustomFilterId
  }

  @action.bound
  private clickOnEdit() {
    const { editCustomFilter } = this.props

    if (this.isCustomFilterSelected) {
      editCustomFilter()
    }
  }

  @action.bound
  private clickOnShare() {
    // TODO: Implement logic to share
  }

  @action.bound
  private clickOnDelete() {
    const { deleteCustomFilter } = this.props

    if (this.isCustomFilterSelected) {
      deleteCustomFilter()
    }
  }

  @action.bound
  private clickOnSave() {
    this.props.onSaveFiltersClicked()
  }
}
